<template>
  <modal name="modal-edit" height="auto" :width="400"
    :scrollable="true" :clickToClose="false" @closed="$emit('input', false)">
    <div class="modal-head mb-3">
      <h4>{{ item?'EDIT':'ADD' }} {{moduleName}}</h4>
      <a href="javascript:;" class="close" @click="closeModal"></a>
    </div>
    <form method="post" @submit.prevent="doSave">
      <div class="form-group">
        <label for="name">Name <span class="text-danger">*</span></label>
        <input type="text" name="name" id="name" ref="inputName"
               :class="{'form-control': true, 'is-invalid': errors.has('name')}"
               v-validate.disable="{ required: true }"
               v-model="name">
        <div class="invalid-feedback">{{ errors.first('name') }}</div>
      </div>
      <div class="form-group">
        <label for="description">Description</label>
        <textarea :class="{'form-control': true}" name="description" id="description" v-model="description"></textarea>
      </div>
      <div class="pt-2 btns btns-2">
        <beat-loader v-if="state == 'saving'"></beat-loader>
        <template v-else>
          <button type="submit" class="btn btn-outline-black mr-2">Save Changes</button>
          <button type="button" class="btn btn-outline-secondary" @click="closeModal">Cancel</button>
        </template>
      </div>
    </form>
  </modal>
</template>

<script>
import { mapState } from 'vuex'
import BeatLoader from 'vue-spinner/src/BeatLoader'
import Service from '@/services/costcategory'

export default {
  components: {
    BeatLoader,
  },
  data () {
    return this.initialState();
  },
  props: ['value', 'item', 'moduleName'],
  computed: mapState({
  }),
  watch: {
    item: 'init',
    value ( newVal ) {
      let self = this;
      if ( newVal ) {
        this.$modal.show('modal-edit', {});
        setTimeout(() => {
          self.$refs.inputName.focus();
        }, 200);
      }
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    initialState (){
      return {
        state: '',
        name: '',
        description: '',
      }
    },
    init () {
      let self = this;
      Object.assign(this.$data, this.initialState());
      if ( !self.item ) {
        return;
      }
      self.name = self.item.name;
      self.description = self.item.description;
    },
    closeModal () {
      this.$modal.hide('modal-edit');
    },
    doSave ( ) {
      let self = this;

      if ( self.state == 'saving' ) {
        return;
      }

      let postData = {};

      if ( !self.item || self.name != self.item.name )
        postData.name = self.name;

      if ( !self.item || self.description != self.item.description )
        postData.description = self.description;


      self.$validator.validateAll()
        .then(ok => {
          if ( ok ) {
            self.state = 'saving';
            if(self.item) {
              Service.save(self.item.id, postData, itemData => {
                self.state = '';
                self.$notify({
                  type: 'success',
                  text: self.moduleName + ' updated successfully'
                });
                self.$emit('item-saved', itemData);
                Object.assign(self.$data, self.initialState());
                self.closeModal();
              }, () => {
                self.state = '';
              });
            }else{
              Service.create(postData, item => {
                self.state = '';
                self.$notify({
                  type: 'success',
                  text: self.moduleName + ' created successfully'
                });
                self.$emit('item-saved', item);
                Object.assign(self.$data, self.initialState());
                self.closeModal();
              }, () => {
                self.state = '';
              });
            }
          }
        });
    }
  }
}
</script>
